{
    "name": "@usereactify/search",
    "description": "React UI library for Reactify Search",
    "version": "5.47.1",
    "license": "MIT",
    "main": "dist/src/index.js",
    "types": "dist/src/index.d.ts",
    "files": [
        "dist",
        "README.md",
        "CHANGELOG.md"
    ],
    "packageManager": "pnpm@8.9.2",
    "scripts": {
        "watch": "tsc --watch",
        "release": "standard-version --tag-prefix release-v",
        "release:beta": "standard-version --tag-prefix beta-v --prerelease beta",
        "prebuild": "rimraf dist",
        "build": "tsc",
        "prettier": "prettier --write .",
        "start": "start-storybook -p 6006",
        "sentry:release:new": "sentry-cli releases new $npm_package_version",
        "sentry:release:upload": "sentry-cli releases files $npm_package_version upload-sourcemaps dist",
        "sentry:release:finalize": "sentry-cli releases finalize $npm_package_version",
        "prepare": "husky install"
    },
    "commitlint": {
        "extends": [
            "@commitlint/config-conventional"
        ]
    },
    "dependencies": {
        "ahooks": "2.10.11",
        "axios": "0.26.1",
        "currency.js": "2.0.4",
        "debug": "4.3.2",
        "ga-gtag": "1.1.5",
        "react-intersection-observer": "9.1.0",
        "react-slider": "2.0.4"
    },
    "peerDependencies": {
        "@appbaseio/reactivesearch": "3.45.0",
        "react": "17 - 18"
    },
    "devDependencies": {
        "@appbaseio/reactivesearch": "3.45.0",
        "@appbaseio/reactivecore": "9.8.0",
        "@babel/plugin-transform-typescript": "7.18.12",
        "@commitlint/cli": "13.2.0",
        "@commitlint/config-conventional": "13.2.0",
        "@storybook/addon-actions": "6.5.10",
        "@storybook/addon-docs": "6.5.10",
        "@storybook/addon-essentials": "6.5.10",
        "@storybook/addon-links": "6.5.10",
        "@storybook/components": "6.5.10",
        "@storybook/react": "6.5.10",
        "@types/debug": "4.1.7",
        "@types/react": "18.0.19",
        "@types/react-dom": "18.0.6",
        "@types/react-slider": "1.3.1",
        "babel-loader": "8.2.2",
        "husky": "^8.0.0",
        "prettier": "2.4.1",
        "pretty-quick": "3.1.1",
        "react": "18.2.0",
        "react-dom": "18.2.0",
        "rimraf": "3.0.2",
        "standard-version": "9.3.1",
        "typescript": "4.4.3"
    }
}
